import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/components/inputtext/InputText';
// import { InputTextarea } from 'primereact/inputtextarea';
import * as PropTypes from 'prop-types';

const DialogType = Object.freeze({
  none: 0,
  rename: 1,
  delete: 2,
  footnote: 3,
});

export default class KeyFigureAdminDialog extends Component {
  getDialogHeader() {
    const { currentDialogType } = this.props;
    switch (currentDialogType) {
      case DialogType.rename:
        return 'Umbenennen';
      case DialogType.delete:
        return 'Löschen';
      case DialogType.footnote:
        return 'Fußnote bearbeiten';
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogText() {
    const { currentDialogType, currentNode } = this.props;
    switch (currentDialogType) {
      case DialogType.rename:
        return <h3>{`Bitte geben Sie eine neue Bezeichnung für '${currentNode.data.name}' ein.`}</h3>;
      case DialogType.delete:
        return <h3>{`Möchten Sie '${currentNode.data.name}' wirklich löschen?`}</h3>;
      case DialogType.footnote:
        return <h3>{`Bitte geben Sie eine neue Fußnote für '${currentNode.data.name}' ein.`}</h3>;
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogConfirmButtonText() {
    const { currentDialogType } = this.props;
    switch (currentDialogType) {
      case DialogType.rename:
        return 'Speichern';
      case DialogType.delete:
        return 'Löschen';
      case DialogType.footnote:
        return 'Speichern';
      default:
        return 'Ungültiger Typ';
    }
  }

  makeTextInput() {
    const { newNodeDataName, setNewNodeDataName } = this.props;
    return (
      <span className="p-float-label" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <InputText
          autoFocus
          style={{ width: '20rem' }}
          id="dialogInpText"
          value={newNodeDataName || ''}
          onChange={(e) => setNewNodeDataName(e.target.value)}
        />
        <label htmlFor="dialogInpText">Bezeichnung</label>
      </span>
    );
  }

  makeFootnoteInput() {
    const { newFootnote, setNewFootnote } = this.props;
    return (
      <span className="p-float-label" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <InputText
          autoFocus
          style={{ width: '20rem' }}
          id="dialogInpText1"
          value={newFootnote || ''}
          onChange={(e) => setNewFootnote(e.target.value)}
          onKeyDown={(e) => setNewFootnote(e.target.value)}
        />
      </span>
    );
  }

  renderFooter() {
    const { confirmDialog, onHide } = this.props;
    return (
      <div>
        <Button
          id="continue"
          label={this.getDialogConfirmButtonText()}
          icon="pi pi-check"
          onClick={confirmDialog}
        />
        <Button
          default
          id="cancel"
          label="Abbrechen"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => { onHide(); }}
        />
      </div>
    );
  }

  render() {
    const { currentDialogType, onHide } = this.props;
    return (
      <Dialog
        header={this.getDialogHeader(currentDialogType)}
        visible={currentDialogType}
        style={{ width: '42rem' }}
        footer={this.renderFooter()}
        onHide={() => onHide()}
        modal
      >
        <div>
          {this.getDialogText(currentDialogType)}
        </div>
        <div>
          {currentDialogType === DialogType.rename ? this.makeTextInput() : undefined}
          {currentDialogType === DialogType.footnote ? this.makeFootnoteInput() : undefined}
        </div>
      </Dialog>
    );
  }
}

KeyFigureAdminDialog.propTypes = {
  onHide: PropTypes.func.isRequired,
  currentDialogType: PropTypes.number.isRequired,
  confirmDialog: PropTypes.func.isRequired,
  currentNode: PropTypes.instanceOf(Object).isRequired,
  newNodeDataName: PropTypes.string.isRequired,
  setNewNodeDataName: PropTypes.func.isRequired,
};
